import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./index.css";
import { SurveyPage } from "./pages/SurveyPage";
import { BrandLogo } from "./components/BrandLogo";

function SurveyRoot() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/s/:token" element={<SurveyPage />} />
        <Route
          path="*"
          element={
            <div className="min-h-screen flex items-center justify-center px-4 bg-surface-alt">
              <div className="w-full max-w-md card p-6 space-y-4 text-center">
                <BrandLogo className="h-8 w-auto mx-auto" />
                <p className="text-sm text-ink-soft">
                  Open the rating link from your support email.
                </p>
              </div>
            </div>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <SurveyRoot />
  </StrictMode>
);
